<template>
    <div class="showcase">
        <nav class="level">
            <div class="level-item has-text-centered">
                <a href="#" @click.prevent="refresh()"><img :src="data.logo"/></a>
            </div>
        </nav>
        <div class="container" v-if="!pickedTrainer">
            <div class="columns is-multiline">
                <div
                    class="column is-4 has-text-centered trainer"
                    v-for="(trainer, index) in data.trainers"
                    @click="pick(index)"
                >
                    <img :src="trainer.image" />
                    <h4 class="title is-4" v-text="trainer.name"></h4>
                </div>
            </div>
        </div>

        <div class="container" v-if="pickedTrainer">
            <div class="featured">
                <div class="columns trainer">
                    <div class="column is-narrow has-text-centered">
                        <img :src="pickedTrainer.image" />
                    </div>
                    <div class="column has-text-centered-mobile">
                        <div class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h4 class="title is-3 is-marginless" v-text="pickedTrainer.name"></h4>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <span class="icon is-large" @click="pick(false)">
                                        <i class="fa fa-close fa-2x"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="content" v-html="pickedTrainer.description"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: { type: Object, required: true },
    },

    data() {
        return {
            pickedEmployee: false,
        }
    },
    created() {},
    methods: {
        pick(index) {
            this.pickedEmployee = index
        },
        refresh() {
            location.reload(true)
        },
    },
    computed: {
        pickedTrainer() {
            return this.pickedEmployee !== false ? this.data.trainers[this.pickedEmployee] : false
        },
    },
}
</script>

<style lang="scss">
@import '../../../sass/admin/variables';

.showcase {
    .level-item img {
        margin-top: 2rem;
    }
    .container {
        padding-left: 1.5rem;
        padding-right: 1.5rem;

        .trainer {
            padding: 3rem;
            img {
                margin-bottom: 1rem;
            }
        }
    }

    .featured {
        .trainer img {
            width: 24rem;
            max-width: 100%;
            margin-right: 2rem;
        }

        .fa-close {
            cursor: pointer;
        }
    }
}
</style>
